import React, { useState } from 'react';
import { useRouteError } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { UiButton, UiIcon } from 'ui-components';
import Layout from 'components/layout/Layout';
import ErrorBoundaryImg from 'assets/img/errorBoundary.svg';
import { useSelector } from 'react-redux';
import { DisplayError } from 'components';
import { StyledRootErrorBoundary } from './RootErrorBoundary.styles';

export default function RootErrorBoundary() {
  const error = useRouteError();
  const { t } = useTranslation();
  const [visible, setVisible] = useState();
  const isClientOnline = useSelector((state) => state.pageReducer.onlineStatus);

  const toggle = () => {
    setVisible((prev) => !prev);
  };

  return (
    <Layout>
      <StyledRootErrorBoundary>
        {!isClientOnline ? (
          <div className='flex center h-full'>
            <DisplayError />
          </div>
        ) : (
          <div className='error-boundary'>
            <img className='image' src={ErrorBoundaryImg} />
            <h1 className='title'>{t('error:errorOccured')}</h1>
            <UiButton onClick={() => window.location.reload()}>
              {t('error:reloadPage')}
            </UiButton>
            <div className='error-toggler' onClick={toggle}>
              {t('error:errorDetails')}
              <UiIcon
                className='mr-8'
                color='#199da3'
                hover='#199da3'
                size={20}
                icon={visible ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}
              />
            </div>
            {visible && <pre className='stack'>{error.stack}</pre>}
          </div>
        )}
      </StyledRootErrorBoundary>
    </Layout>
  );
}
